import { createFileRoute } from '@tanstack/react-router';
import LazyRoute from '../components/LazyRoute';
import { TablePageLoader } from '@/components/ui/page-loader';

export const Route = createFileRoute('/_protected/schedules/')({
  component: () => (
    <LazyRoute
      loader={() => import('@/components/schedules')}
      fallback={<TablePageLoader />}
    />
  ),
});
